import { genHtmlOptions, genMenuItems, genGridOptions } from '../../utils';

export const compare = (a, b) => {
    if (a.idx < b.idx) {
        return -1;
    }
    if (a.idx > b.idx) {
        return 1;
    }
    return 0;
};




export const mapped_user_roles = (tour_user, roleMap) => {
    let formatted_roles = [];
    tour_user.user?.roles?.map((r) => {
        if (r !== null) {
            formatted_roles.push(roleMap[r]);
        }
        return null;
    });
    return formatted_roles;
};

export const filteredMaxedTags = (tag_categories, tags) => {
    let filtered = [...tag_categories];

    filtered = filtered.filter((tc) => tc.category.code !== 'departure');

    for (let index = 0; index < tag_categories.length; index++) {
        if (tag_categories[index]?.max_tags === 1) {
            if (tags.filter((tag) => tag?.category?.id === tag_categories[index]?.category?.id).length > 0) {
                filtered = filtered.filter((atc) => atc?.id !== tag_categories[index]?.id);
            }
        }
    }

    return filtered;
};

export const blank_trip_user = {
    date: null,
    tags: [],
    role: null,

    is_existing: false,
    is_staff: false,
    attachments: [],
    departure: null,

    order_ref: '',
    departure_key: '',

    airbnb_host_id: null,
    airbnb_channel_id: null,
    airbnb_direct_user_thread_id: null,

    exclude_from_group_chat: false,
    
    user: {
        display_name: '',
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        roles: [],
    },
};



export const validateUser = (user, serverErrors, requires_departure, missing_required_tags) => {
    const errors = { ...serverErrors };
    let canSave = !serverErrors || Object.keys(serverErrors) <= 0 || (!serverErrors?.phone?.error && !serverErrors?.email?.error);

    if (!user.user?.email) {
        canSave = false
    }
    if (requires_departure && !user.departure?.tag?.id) {
        canSave = false
    }
    if (missing_required_tags) {
        canSave = false
    }
    return { canSave, errors };
};


export const checkRequiredTagsSelected = (tags, tripUser, setClientErrors) => {

    let checkIfNotAllRequiredTagsChanged = tags ? tags.filter((tag) => !tag.id) : tripUser.tags.filter((tag) => !tag.id);
    let tag_list = tags ? [...tags] : [...tripUser.tags];
    for (let tag of tag_list) {
        // show input error only after onBlur, initial check is only for disabling the Add button
        if (!tag.id && setClientErrors) {
            tag.error = true;
        }
    }
    if (tag_list.filter((tag) => tag.error || !tag.id).length > 0) {
        setClientErrors && setClientErrors((prev) => ({ ...prev, missingRequiredTags: true }));
        return false;
    }
    if (checkIfNotAllRequiredTagsChanged.length > 0) {
        setClientErrors && setClientErrors((prev) => ({ ...prev, missingRequiredTags: true }));
        return false;
    }
    setClientErrors && setClientErrors((prev) => ({ ...prev, missingRequiredTags: false }));
    // if not all selected return true
    return true;
};

export const ERROR_MESSAGES = {
    validEmailAddress: 'Please enter a valid email address',
    unicodeCharactersFound: 'Please do not use hidden unicode characters in this field',
    phoneServerCheckError: 'Please enter a valid phone number',
    userFoundBespoke: 'User is already a member of this tour'
}

export const BOOKING_STATES = {};
export const BOOKING_STATE_ON_HOLD = 0;
export const BOOKING_STATE_BOOKED = 1;
export const BOOKING_STATE_CANCELLED = 2;
export const BOOKING_STATE_CANCELLED_ON_HOLD = 3;
export const BOOKING_STATE_PENDING_CONFIRMATION = 4;
BOOKING_STATES[BOOKING_STATE_ON_HOLD] = 'On hold';
BOOKING_STATES[BOOKING_STATE_PENDING_CONFIRMATION] = 'Pending confirmation';
BOOKING_STATES[BOOKING_STATE_BOOKED] = 'Booked';
BOOKING_STATES[BOOKING_STATE_CANCELLED] = 'Cancelled';
BOOKING_STATES[BOOKING_STATE_CANCELLED_ON_HOLD] = 'Cancelled on hold';

export const bookingStatesMenuItems = genMenuItems(BOOKING_STATES);
export const bookingStatesOptions = genHtmlOptions(BOOKING_STATES);
export const bookingStatesGridOptions = genGridOptions(BOOKING_STATES);

export const CHECKIN_SOURCES = {};
export const CHECKIN_SOURCE_LOCAL = 0;
export const CHECKIN_SOURCE_RESTECH = 1;
export const CHECKIN_SOURCE_DASHBOARD = 2;
export const CHECKIN_SOURCE_TEST = 3;
CHECKIN_SOURCES[CHECKIN_SOURCE_LOCAL] = 'App';
CHECKIN_SOURCES[CHECKIN_SOURCE_RESTECH] = 'Booking system';
CHECKIN_SOURCES[CHECKIN_SOURCE_DASHBOARD] = 'Dashboard';
CHECKIN_SOURCES[CHECKIN_SOURCE_TEST] = 'Test';

export const checkinSourcesMenuItems = genMenuItems(BOOKING_STATES);
export const checkinSourcesOptions = genHtmlOptions(BOOKING_STATES);
export const checkinSourcesGridOptions = genGridOptions(CHECKIN_SOURCES);

export const PRECHECKIN_STATUSES = {};
export const PRECHECKIN_STATUS_NOT_COMPLETED = 0;
export const PRECHECKIN_STATUS_PARTIAL = 1;
export const PRECHECKIN_STATUS_COMPLETED = 2;
// Every guest saved details (or was skipped), but the final waivers/consent screen was not submitted.
export const PRECHECKIN_STATUS_DETAILS_COMPLETED = 3;
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_NOT_COMPLETED] = 'Not completed';
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_PARTIAL] = 'Partially completed';
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_DETAILS_COMPLETED] = 'Details completed';
PRECHECKIN_STATUSES[PRECHECKIN_STATUS_COMPLETED] = 'Completed';

// Progress order, 0 → 1 → 3 → 2: listing by key would put "Details completed" after "Completed".
export const PRECHECKIN_STATUS_ORDER = [
    PRECHECKIN_STATUS_NOT_COMPLETED, PRECHECKIN_STATUS_PARTIAL, PRECHECKIN_STATUS_DETAILS_COMPLETED, PRECHECKIN_STATUS_COMPLETED,
].map(String);

export const precheckinStatusesMenuItems = genMenuItems(PRECHECKIN_STATUSES, PRECHECKIN_STATUS_ORDER);
export const precheckinStatusesOptions = genHtmlOptions(PRECHECKIN_STATUSES, {}, PRECHECKIN_STATUS_ORDER);
export const precheckinStatusesGridOptions = genGridOptions(PRECHECKIN_STATUSES, PRECHECKIN_STATUS_ORDER);

export const SOURCES = {};
export const SOURCE_EDIT_API = 0;
export const SOURCE_SELFREG_PAGE = 1;
export const SOURCE_TRIP_CODE = 2;
export const SOURCE_XML = 3;
export const SOURCE_INTEGRATION = 4;
export const SOURCE_OTHER = 5;
export const SOURCE_TAG = 6;
export const SOURCE_BOOKING_REF = 7;
export const SOURCE_WAIVER = 8;
export const SOURCE_CATALOG = 9;
export const SOURCE_PARENT_BOOKING = 10;

SOURCES[SOURCE_EDIT_API] = "Dashboard";
SOURCES[SOURCE_SELFREG_PAGE] = "Self-registration";
SOURCES[SOURCE_TRIP_CODE] = "Trip code";
SOURCES[SOURCE_XML] = "XML";
SOURCES[SOURCE_INTEGRATION] = "Integration";
SOURCES[SOURCE_OTHER] = "Other";
SOURCES[SOURCE_TAG] = "Tag";
SOURCES[SOURCE_BOOKING_REF] = "Booking reference";
SOURCES[SOURCE_WAIVER] = "Waiver";
SOURCES[SOURCE_CATALOG] = "Catalog";
SOURCES[SOURCE_PARENT_BOOKING] = "Parent booking";

export const sourcesGridOptions = genGridOptions(SOURCES);

// Booking_Ticket.TYPES (backend demo/models.py): every format a ticket can have.
export const TICKET_FORMATS = {};
export const TICKET_FORMAT_QRCODE = 0;
export const TICKET_FORMAT_PKPASS_URL = 1;
export const TICKET_FORMAT_URL = 2;
export const TICKET_FORMAT_FILE = 3;
export const TICKET_FORMAT_TEXT = 4;
export const TICKET_FORMAT_RESELLER_REF = 5;
export const TICKET_FORMAT_SUPPLIER_REF = 6;
export const TICKET_FORMAT_GOOGLE_WALLET = 7;
export const TICKET_FORMAT_IMAGE_URL = 8;
TICKET_FORMATS[TICKET_FORMAT_QRCODE] = 'QR Code';
TICKET_FORMATS[TICKET_FORMAT_PKPASS_URL] = 'Apple Wallet link';
TICKET_FORMATS[TICKET_FORMAT_URL] = 'URL';
TICKET_FORMATS[TICKET_FORMAT_FILE] = 'File';
TICKET_FORMATS[TICKET_FORMAT_TEXT] = 'Text';
TICKET_FORMATS[TICKET_FORMAT_RESELLER_REF] = 'Reseller reference';
TICKET_FORMATS[TICKET_FORMAT_SUPPLIER_REF] = 'Supplier reference';
TICKET_FORMATS[TICKET_FORMAT_GOOGLE_WALLET] = 'Google Wallet link';
TICKET_FORMATS[TICKET_FORMAT_IMAGE_URL] = 'Image URL';
// Formats whose value is a web address (the backend refuses anything but a full http(s) URL).
export const TICKET_LINK_FORMATS = [TICKET_FORMAT_PKPASS_URL, TICKET_FORMAT_URL, TICKET_FORMAT_GOOGLE_WALLET, TICKET_FORMAT_IMAGE_URL];

export const TICKET_UNITS = {};
export const TICKET_UNIT_INDIVIDUAL = 0;
export const TICKET_UNIT_GROUP = 1;
TICKET_UNITS[TICKET_UNIT_INDIVIDUAL] = 'Individual';
TICKET_UNITS[TICKET_UNIT_GROUP] = 'Group';

export const SURVEY_STATES = {};
export const SURVEY_NOT_SENT = 0;
export const SURVEY_SENT = 1;
export const SURVEY_OPENED = 2;
export const SURVEY_SUBMITTED = 3;
export const SURVEY_NOT_NEEDED = 4;
SURVEY_STATES[SURVEY_NOT_SENT] = "Scheduled";
SURVEY_STATES[SURVEY_SENT] = "Sent";
SURVEY_STATES[SURVEY_OPENED] = "Opened";
SURVEY_STATES[SURVEY_SUBMITTED] = "Submitted";
SURVEY_STATES[SURVEY_NOT_NEEDED] = "Disabled";

export const surveyStatesMenuItems = genMenuItems(SURVEY_STATES);
export const surveyStatesOptions = genHtmlOptions(SURVEY_STATES);
export const surveyStatesGridOptions = genGridOptions(SURVEY_STATES);
